exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "small[data-v-50a517db]{color:gray}.acl-public[data-v-50a517db]{color:#00b400}.acl-intern[data-v-50a517db]{color:#dacd00}.acl-privat[data-v-50a517db]{color:#be0000}.btn[data-v-50a517db]{padding:4px 10px}.cc-btn-menue[data-v-50a517db]{padding-left:10px;padding-right:0}.media-right[data-v-50a517db]{min-width:100px}.media-left[data-v-50a517db]{padding-left:15px}.cc-kombox-typ[data-v-50a517db]{padding-bottom:30px}.cc-kombox-body[data-v-50a517db]{border-left:0 solid red;padding-left:8px;line-height:1.1em;min-width:120px}.media-left .glyphicon[data-v-50a517db]{padding-right:0;font-size:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-50a517db&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/KomboxUserCaller.vue
// module id = 204
// module chunks = 0